import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IContentMobile } from "../../../Pages/ContentMobile/IContentMobile";

export const ListContentMobileSlice = createSlice({
  name: "ListContentMobileSlice",
  initialState: {} as IReduxState<IContentMobile[]>,
  reducers: {
    listContentMobile: (state) => {
      state.isLoading = true;
    },
    successlistContentMobile: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistContentMobile: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  failurelistContentMobile,
  listContentMobile,
  successlistContentMobile,
} = ListContentMobileSlice.actions;

export default ListContentMobileSlice.reducer;
